import React from "react";
import { JaaSMeeting as JitsiMeeting } from "@jitsi/react-sdk";
import { useSearchParams, useNavigate } from "react-router-dom";
import Button from "common/button";

const JAAS_ENABLED = false; // Set this to true to enable Jitsi meetings

const JaaSMeeting = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const room = searchParams.get("room");
  const jwt = searchParams.get("jwt");
  const jitsiAppId =
    process.env.REACT_APP_JITSI_APP_ID ||
    "vpaas-magic-cookie-69283bf24af3402e99262d11305ac47e";

  if (!room) {
    return <div>Meeting room not found. Please check your meeting URL.</div>;
  }

  if (!JAAS_ENABLED) {
    return (
      <div style={{ textAlign: "center", padding: "20px" }}>
        <h2>We have switched to Whereby for online classes</h2>
        <p>
          Please go back to your classes and join the class again to access the
          Whereby meeting room.
        </p>
        <Button type="primary" onClick={() => navigate("/my-classes")}>
          Back to My Classes
        </Button>
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        position: "fixed",
        top: 0,
        left: 0,
      }}
    >
      <JitsiMeeting
        appId={jitsiAppId}
        roomName={room}
        jwt={jwt || ""}
        configOverwrite={{
          disableAGC: true,
          p2p: { enabled: false },
        }}
        interfaceConfigOverwrite={{
          VIDEO_LAYOUT_FIT: "nocrop",
          MOBILE_APP_PROMO: false,
          TILE_VIEW_MAX_COLUMNS: 4,
        }}
        onApiReady={(api) => {
          api.on("videoConferenceJoined", () => {
            api.executeCommand("setAssumedBandwidthBps", 1500000);
          });
        }}
        getIFrameRef={(iframeRef) => {
          // eslint-disable-next-line no-param-reassign
          iframeRef.style.height = "100%";
          // eslint-disable-next-line no-param-reassign
          iframeRef.style.width = "100%";
        }}
      />
    </div>
  );
};

export default JaaSMeeting;
